import axios from 'axios';
import qs from 'query-string';
import {
  CLIENT_ID, CLIENT_SECRET, REDIRECT_URI, SCOPE, SSO_URL,
} from './config';

export const SsoService = {
  getIdToken(code) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return axios.get(`${SSO_URL}/oauth/token?client_id=${CLIENT_ID}&client_secret=${CLIENT_SECRET}&response_type=token&scope=${SCOPE}&redirect_uri=${REDIRECT_URI}&code=${code}&grant_type=authorization_code`, config)
      .catch((error) => {
        throw new Error(`[RWV] SsoService ${error}`);
      });
  },
  verifyToken(idToken) {
    const requestBody = {
      id_token: idToken,
    };
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return axios.post(`${SSO_URL}/api/verify/token`, qs.stringify(requestBody), config).catch((error) => {
      throw new Error(`[RWV] SsoService ${error}`);
    });
  },
};

const ApiService = {
  query(resource, params) {
    return axios.get(`/api/${resource}`, {
      params,
    });
  },

  downloadQuery(resource, params) {
    return axios.get(`/api/${resource}`, {
      params,
      responseType: 'blob',
    });
  },

  get(resource) {
    return axios.get(`/api/${resource}`);
  },

  post(resource, params) {
    return axios.post(`/api/${resource}`, params);
  },

  postFile(resource, params) {
    return axios.post(`/api/${resource}`, params,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  },

  put(resource, params) {
    return axios.put(`/api/${resource}`, params);
  },

  delete(resource, params) {
    return axios.delete(`/api/${resource}`, {
      params,
    });
  },
};

export default ApiService;
